import AuthService from "../login/auth.service";
import { comprobantes, basaSipacoop } from "../../components/generico/utils/UrlAPI";
import axios from "axios";
//servicio
class TransferInterbancaService {
  async getCuentasExternas() {
    var config = {
      method: "get",
      url: basaSipacoop + "cuentasdestinos/cedula",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken()
      }
    };
    return await axios(config);
  }
  async getEntidades() {
    var config = {
      method: "get",
      url: basaSipacoop + "entidades",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken()
      }
    };
    return await axios(config);
  }
  async getTiposDocumentos() {
    var config = {
      method: "get",
      url: basaSipacoop + "tiposdocumentos",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken()
      }
    };
    return await axios(config);
  }
  async addCuentaExterna(
    nombreDestino,
    ctaDestino,
    tipoDocumento,
    nroDocDestino,
    entidad
  ) {
    var data = JSON.stringify({
      cedulaSocio: AuthService.getSocio().numeroCedula,
      nombreDestino: nombreDestino,
      tipoCuenta: "EXTERNA",
      cuentaDestino: ctaDestino,
      entidad: { id: entidad },
      tipoDocumento: { id: tipoDocumento },
      numeroDocumentoDestino: nroDocDestino,
    });
    var config = {
      method: "post",
      url: basaSipacoop + "cuentasdestinos",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken()
      },
      data: data,
    };
    return await axios(config);
  }
  async deleteCuentaExterna(dato) {
    var config = {
      method: "delete",
      url: basaSipacoop + "cuentasdestinos/" + dato,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken()
      },
    };
    return await axios(config);
  }

  async confirmarTransferenciaInterbancaria(
    importe,
    moneda,
    motivo,
    ctaOrigen,
    tipoDocOrigen,
    nombreOrigen,
    codEntidad,
    ctaDestino,
    tipoDocDestino,
    docDestino,
    nombreDestino,
    pinTransaccional,
    transferenciaDatosRepetidos
  ) {

    var data = JSON.stringify({
      importe: importe,
      moneda: moneda,
      motivo: motivo,
      cuentaOrigen: ctaOrigen,
      tipoDocumentoOrigen: tipoDocOrigen,
      documentoOrigen: AuthService.getSocio().numeroCedula,
      nombreOrigen: nombreOrigen,
      codigoEntidad: codEntidad,
      cuentaDestino: ctaDestino,
      tipoDocumentoDestino: tipoDocDestino,
      documentoDestino: docDestino,
      nombreDestino: nombreDestino,
      pinTransaccional: pinTransaccional,
      canal: "WEB",
      transferenciaDatosRepetidos
    });

    var config = {
      method: "post",
      url: basaSipacoop + "transferencias/enviar",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken()
      },
      data: data,
    };
    return await axios(config);
  }


  async generarOTP(
    
  ) {

    var config = {
      method: "post",
      url: basaSipacoop + "transferencias/generarOtp",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken()
      },
    };
    return await axios(config);
  }

  async validarOTP( codigootp
    
    
  ) {

    var config = {
      method: "post",
      url: basaSipacoop + "transferencias/validarOtp/" + codigootp ,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken()
      },
    
    };
    return await axios(config);
  }


  async descagarComponente(
    _titulo,
    _nroOperacion,
    _cuentaTitular,
    _tipo,
    _moneda,
    _cuentaDebito,
    _cuentaCredito,
    _importeDebito,
    _importeCredito,
    _titularCuentaDestino,
    _entidad,
    _tipoDocDestino,
    _documentoDestino
  ) {
    var data = JSON.stringify({
      titulo: _titulo,
      nroOperacion: _nroOperacion,
      cuentaTitular: _cuentaTitular,
      tipo: _tipo,
      moneda: _moneda,
      cuentaDebito: _cuentaDebito,
      cuentaCredito: _cuentaCredito,
      importeDebito: _importeDebito,
      importeCredito: _importeCredito,
      titularCuentaDestino: _titularCuentaDestino,
      entidad: _entidad,
      tipoDocDestino: _tipoDocDestino,
      documentoDestino: _documentoDestino
    });
    var _url = comprobantes + "comprobantes/v2/transferencias-interbancarias";
    var config = {
      method: "POST",
      url: _url,
      data: data,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
    };
    return await axios(config);
  }
}
export default new TransferInterbancaService();